import React from 'react';

const TeamSection = () => {
  const team = [
  {
    name: 'Erik Haugen',
    role: 'Administrerende direktør',
    bio: 'Tidligere leder i Statens vegvesen med 15 års erfaring innen norsk infrastruktur og transportpolitikk.',
    img: "https://img.rocket.new/generatedImages/rocket_gen_img_1bfef8bd5-1763295388609.png",
    alt: 'Profesjonelt portrettbilde av Erik Haugen, administrerende direktør — mann i dress med selvsikker holdning'
  },
  {
    name: 'Ingrid Solberg',
    role: 'Teknisk direktør',
    bio: 'Sivilingeniør fra NTNU. Bygget skalerbare systemer for Telenor og Aker Solutions før hun grunnla Veiassistent.',
    img: "https://img.rocket.new/generatedImages/rocket_gen_img_11e5f8340-1772192353406.png",
    alt: 'Profesjonelt portrettbilde av Ingrid Solberg, teknisk direktør — kvinne i profesjonell setting med laptop'
  },
  {
    name: 'Lars Bakke',
    role: 'Produktsjef',
    bio: 'UX-ekspert med bakgrunn fra Finn.no og Kolonial.no. Brenner for enkle løsninger på komplekse problemer.',
    img: "https://img.rocket.new/generatedImages/rocket_gen_img_174efa360-1772115493075.png",
    alt: 'Profesjonelt portrettbilde av Lars Bakke, produktsjef — mann med vennlig smil i kontormiljø'
  },
  {
    name: 'Marte Christensen',
    role: 'Kundeansvarlig',
    bio: 'Tidligere konsulent i McKinsey. Leder vårt team for bedriftskunder og flåteforvaltning med fokus på ROI.',
    img: "https://img.rocket.new/generatedImages/rocket_gen_img_18b47f11c-1766204529712.png",
    alt: 'Profesjonelt portrettbilde av Marte Christensen, kundeansvarlig — kvinne i forretningsklær med profesjonelt uttrykk'
  }];


  return (
    <section style={{ padding: '0 24px 80px', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '40px' }}>
        <div style={{ width: '4px', height: '32px', background: '#FF5722' }} />
        <div>
          <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.16em', textTransform: 'uppercase', color: '#FF5722', display: 'block', marginBottom: '4px' }}>Teamet</span>
          <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '28px', fontWeight: 700, color: 'var(--color-foreground)', letterSpacing: '0.01em' }}>Menneskene bak Veiassistent</h2>
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px' }}>
        {team?.map((member, i) =>
        <div key={i} style={{ position: 'relative', background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(224,228,232,0.08)', borderRadius: '2px', overflow: 'hidden' }}>
            {/* Offset accent */}
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: i % 2 === 0 ? '#FF5722' : 'rgba(0,79,152,0.6)' }} />
            {/* Photo */}
            <div style={{ height: '200px', overflow: 'hidden', position: 'relative' }}>
              <img
              src={member?.img}
              alt={member?.alt}
              style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top', filter: 'grayscale(20%)' }} />
            
              <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, transparent 50%, rgba(26,29,32,0.9) 100%)' }} />
            </div>
            {/* Info */}
            <div style={{ padding: '20px' }}>
              <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: '16px', fontWeight: 700, color: 'var(--color-foreground)', marginBottom: '4px' }}>{member?.name}</h3>
              <p style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#FF5722', marginBottom: '12px' }}>{member?.role}</p>
              <p style={{ fontFamily: 'var(--font-body)', fontSize: '13px', color: 'var(--color-muted-foreground)', lineHeight: 1.65 }}>{member?.bio}</p>
            </div>
          </div>
        )}
      </div>
    </section>);

};

export default TeamSection;